module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "sign-up-illustration-teams.3e29caf5.png" + "?" + Date.now();